<template>
  <div class='page page__list'>
    <search-bar
      @search="onSearch"
      name="sad_prodcode,sad_prodname,sa_vendname,sa_code"
      placeholder="输入物料、供应商、单号进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.sad_id"
        :to="'/purchase/sample_apply/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.sad_prodname}}</p>
          <p class="list-item-muted">{{item.sad_prodcode}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.sa_code}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.sa_status!='已审核'}"
          >{{item.sa_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/sample/samples/list",
      params: {
        mode: "DETAIL",
        number: 1,
        size: 10,
      },
      filters: [
        {
          type: "date",
          name: "sa_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              mode: "DETAIL"
            },
            {
              value: 1,
              label: "待审核",
              condition: "sa_status='未审核'",
            },
            {
              value: 2,
              label: "已审核",
              condition: "sa_status='已审核'",
            }
          ]
        }
      ]
    }
  }
}
</script>